
//hotpoints
$('.hotpoints').find('.hotpoints--poi').on('hover touchend',function(){
    if($(this).hasClass('hover')) {
        $(this).parents().find('.hotpoints--poi').removeClass('hover');
        $(this).parents().find('.hotpoints--poi-txt').removeClass('hover');
    }
    else {
        $(this).parents().find('.hotpoints--poi').removeClass('hover');
        $(this).parents().find('.hotpoints--poi-txt').removeClass('hover');
        var classes = $(this).attr('class');
        var current = classes.substr(classes.length - 1);
        $(this).addClass('hover');
        $(this).parents().find('.hotpoints--poi-txt').eq($(this).index()).addClass('hover');
        sendStats('hotpoint', 'hotpoint-'+current, '');
    }
});